<template>
	<div>
		<header class="page-title">
			<h2>Provider Portal Users</h2>
			<div class="ml-auto" v-if="userRoles.includes('provider_portal.users.create')">
				<a @click="openModal()" class="btn btn-md btn-success"><i class="fas fa-plus"></i> New User</a>
			</div>
		</header>

		<provider-portal-user-filter
				:data-endpoint="endPoint"
				:data-url-params="urlParams"
		></provider-portal-user-filter>

		<provider-portal-user-list :data-endpoint="endPoint"
					  :data-url-params="urlParams"
					  :data-user-list="userList"
		></provider-portal-user-list>

		<modal @close="closeModal" v-show="isModalVisible">
			<template slot="header">
				<h4 class="modal-title">Create New Provider Portal User</h4>
			</template>
			<template slot="body">
				<div class="form-group">
					<label for="name">Name</label>
					<input class="input-large" id="name" required type="text" v-model="newUserData.name">
					<p class="input-error" v-if="errors.errors['name']">{{ errors.errors['name'] }}</p>
				</div>
				<div class="form-group">
					<label for="email">Email Address</label>
					<input id="email" required type="email" v-model="newUserData.email" value="">
					<p class="input-error" v-if="errors.errors['email']">{{ errors.errors['email'] }}</p>
				</div>
			</template>
			<template slot="footer">
				<a @click="closeModal" aria-label="Close modal" class="btn btn-md btn-primary modal-close" href="#"><i
						class="fas fa-times"></i> Cancel</a>
				<a @click="createUser" class="btn btn-md btn-success" href="#"><i class="fas fa-save"></i> Save Changes</a>
			</template>
		</modal>
	</div>
</template>

<script>
	import modal from "../../Modal/DefaultModal.vue";
	import Errors from '../../../Utils/Errors.js'

	export default {
		components: {
			modal
		},
		props: {
			dataUserList: {
				type: Array
			},
			dataEndpoint: {
				type: String
			},
			dataUrlParams: {
				type: Object,
				required: false
			},
		},
		data() {
			return {
				userList: this.dataUserList,
				endPoint: this.dataEndpoint,
				urlParams: this.dataUrlParams || [],
				isModalVisible: false,
				newUserData: {
					name: null,
					email: null
				},
				errors: new Errors(),
				userRoles: this.$currentUserRoles,
			}
		},
		methods: {
			openModal: function () {
				this.isModalVisible = true;
			},
			closeModal: function () {
				this.isModalVisible = false;
			},
			createUser: function () {
				let vm = this;

				axios.post('/api/' + this.$selectedSite.slug + '/providerPortalUsers', vm.newUserData)
					.then(response => {
						if (response.data.success) {
							this.$toastr.success('New user saved.');
							vm.closeModal();
							setTimeout(function () {
								window.location.reload();
							}, 1000);
						} else {
							vm.errors.record(response.data);
							this.$toastr.error('Save new user failed.', 'Error');
						}
					})
					.catch(e => {
						vm.errors.record(e.response.data);
						this.$toastr.error('Save new user failed.', 'Error');
					});
			}
		}
	}
</script>

<style scoped>

</style>
